// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2xGgy","addWidgetButton":"Header_addWidgetButton__1Vg_8","dashboardTabs":"Header_dashboardTabs__Ztau8","active":"Header_active__2r17P"};